import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {Broker, ColorScheme} from '../../core/types/page-configuration.types';

@Injectable({
    providedIn: "root",
})
export class LayoutService {
    private _colorScheme: BehaviorSubject<ColorScheme | null> = new BehaviorSubject<ColorScheme | null>(null);
    private _logoSrc: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
    private _brokerInfo: BehaviorSubject<Broker | null> = new BehaviorSubject<Broker | null>(null);

    get colorScheme$(): Observable<ColorScheme | null> {
        return this._colorScheme.asObservable();
    }

    setColorScheme(colorScheme: ColorScheme | null): void {
        this._colorScheme.next(colorScheme);
    }

    get logoSrc$(): Observable<string | null> {
        return this._logoSrc.asObservable();
    }

    setLogoSrc(logoSrc: string | null): void {
        this._logoSrc.next(logoSrc);
    }

    get brokerInfo$(): Observable<Broker | null> {
        return this._brokerInfo.asObservable();
    }

    setBrokerInfo(brokerInfo: Broker | null): void {
        this._brokerInfo.next(brokerInfo);
    }
}
